import React, { useMemo } from "react";
import { useGetHtmlApiQuery } from "../../redux/services/apiHome";
import Loader from "../../components/Loader";

import InnerBannerBreadcrumb from "../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import { useLanguageTranslation } from "../../hooks/useLanguageTranslation";
import { useSelector } from "react-redux";
import { extractDateFromHtml, getDateUpdate } from "../../Utils/utils";
import PageLastUpdated from "../../components/shared/PageLastUpdated";
import useSeo from "../../hooks/useSeo";
import { useLocation } from "react-router-dom";

const IntegrityPact = () => {
  const { languageType } = useSelector((state) => state.homeSlice);

  const { data: integrityPact = {}, isLoading: integrityPactIsLoading } =
    useGetHtmlApiQuery({ url: 155, lang: languageType });
  const { getText } = useLanguageTranslation();

  const pageBody = integrityPact?.body?.[0]?.value ?? "No content available";

  const lastUpdatedOn = useMemo(() => {
    return getDateUpdate(integrityPact?.changed?.[0]?.value);
  }, [integrityPact]);

  // for SEO
  const { pathname } = useLocation();
  const { innerBannerImage, innerBannerTitle } = useSeo({ pathname });

  if (integrityPactIsLoading) {
    return <Loader />;
  }

  return (
    <>
      <InnerBannerBreadcrumb
        title={getText("Tender", "निविदा")}
        titleLink="/tender/integrity-pact"
        levelTwo={true}
        levelThree={false}
        bannerImage={innerBannerImage}
        titleTwo={innerBannerTitle}
        isActive={innerBannerTitle}
      />

      <div className="inner-container">
        <div className="container">
          <section className="ourCompany">
            <div className="container">
              <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />

              <div className="row mb-5">
                <div className="col-12 col-sm-12 col-md-12 col-lg-12 mvDescWrap">
                  {/* <div className="title-sec">
                    <h4>{pageTitle}</h4>
                  </div> */}
                  <div className="about_inntxt integrity">
                    <div dangerouslySetInnerHTML={{ __html: pageBody }}></div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default IntegrityPact;
